var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5629_8475)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5629_8475)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84392 3.16007C2.91173 1.99646 3.86642 1.08789 5.02127 1.08789H5.59897C6.75382 1.08789 7.70851 1.99646 7.77632 3.16007L7.88677 5.05527C7.90607 5.38628 7.65585 5.6704 7.32789 5.68988C6.99993 5.70934 6.71843 5.45678 6.69913 5.12577L6.58868 3.23057C6.55786 2.70166 6.1239 2.28868 5.59897 2.28868H5.02127C4.49634 2.28868 4.06238 2.70166 4.03156 3.23057L3.92111 5.12577C3.90181 5.45678 3.62031 5.70934 3.29235 5.68988C2.96439 5.6704 2.71417 5.38628 2.73347 5.05527L2.84392 3.16007Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69261 8.31845C1.73667 8.77679 2.10621 9.10441 2.56603 9.12844C3.13309 9.15809 4.03132 9.18902 5.31036 9.18902C6.5894 9.18902 7.48764 9.15809 8.05469 9.12844C8.51452 9.10441 8.88405 8.77679 8.92811 8.31845C8.96308 7.9547 8.99279 7.45235 8.99279 6.79544C8.99279 6.13853 8.96308 5.63617 8.92811 5.27242C8.88405 4.81409 8.51452 4.48646 8.05469 4.46243C7.48764 4.43279 6.5894 4.40186 5.31036 4.40186C4.03132 4.40186 3.13309 4.43279 2.56603 4.46243C2.10621 4.48646 1.73667 4.81409 1.69261 5.27242C1.65765 5.63617 1.62793 6.13853 1.62793 6.79544C1.62793 7.45235 1.65765 7.9547 1.69261 8.31845Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64457 6.89997C5.88353 6.77823 6.04719 6.52989 6.04719 6.24332C6.04719 5.83658 5.71745 5.50684 5.31071 5.50684C4.90396 5.50684 4.57422 5.83658 4.57422 6.24332C4.57422 6.52989 4.73788 6.77823 4.97684 6.89997L4.8135 7.71668C4.78093 7.87952 4.86498 8.04007 5.0292 8.06469C5.1065 8.07627 5.20032 8.08454 5.31071 8.08454C5.42109 8.08454 5.51491 8.07627 5.59221 8.06469C5.75643 8.04007 5.84048 7.87952 5.80791 7.71668L5.64457 6.89997Z",
    fill: "#0F172A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5629_8475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83784,
    height: 8.83784,
    fill: "white",
    transform: "translate(0.891602 0.526855)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5629_8475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83784,
    height: 8.83784,
    fill: "white",
    transform: "translate(0.891602 0.719727)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1590f2fbdc1d2889c66b5196d45cc50f.svg";
export { ForwardRef as ReactComponent };